export default __webpack_public_path__ + "static/media/bkk-pembelian.91c4af72.png";